import React from "react";
import { useNavigate } from "react-router-dom";
import { StatusBar, Logo } from "../components/Shell";
import { DollarSign, GraduationCap, TrendingUp, ShieldCheck } from "lucide-react";

export default function Splash() {
  const navigate = useNavigate();

  const tiles = [
    { icon: DollarSign, label: "Earn Real Money", tint: "#f5911e" },
    { icon: TrendingUp, label: "Rank Up", tint: "#4fae3f" },
    { icon: ShieldCheck, label: "Safe & Secure", tint: "#22a7c9" },
    { icon: GraduationCap, label: "Learn & Grow", tint: "#8b5cf6" },
  ];

  return (
    <div className="gd-screen" style={{ background: "linear-gradient(170deg,#4a63d6 0%,#26357f 60%,#1c2865 100%)" }}>
      <StatusBar dark={false} />
      <div className="gd-scroll flex flex-col items-center px-8 pb-10 pt-10">
        <div className="gd-float mt-6 grid place-items-center rounded-[28px] bg-white/95 p-6 shadow-2xl">
          <img src="/assets/logo.png" alt="GEN-DO" className="h-28 w-28 object-contain" />
        </div>

        <h1 className="mt-8 text-4xl font-black text-white">
          GEN<span className="text-[#f5911e]">-DO</span>
        </h1>
        <div className="mt-2 rounded-md bg-[#f5911e] px-3 py-1 text-[11px] font-extrabold tracking-[3px] text-white">
          GROWING SUCCESS!
        </div>
        <p className="mt-3 text-sm font-semibold tracking-[2px] text-white/70">EARN · LEARN · GROW</p>

        <div className="mt-8 grid w-full grid-cols-2 gap-3 gd-stagger">
          {tiles.map((t) => (
            <div key={t.label} className="flex flex-col items-center gap-2 rounded-2xl bg-white/10 p-4 backdrop-blur">
              <div className="grid h-11 w-11 place-items-center rounded-full" style={{ background: t.tint }}>
                <t.icon size={20} color="#fff" />
              </div>
              <span className="text-center text-xs font-bold text-white">{t.label}</span>
            </div>
          ))}
        </div>

        <div className="mt-auto w-full pt-8">
          <button onClick={() => navigate("/onboarding")} className="gd-orange-btn w-full rounded-2xl py-4 text-base font-extrabold">
            Get Started
          </button>
          <p className="mt-4 text-center text-xs text-white/60">The Neighborhood Hustle Platform</p>
        </div>
      </div>
    </div>
  );
}
